import { ZButton } from "@/shared/components/button";
import { Modal, ModalContent } from "@nextui-org/react";
import { X } from "lucide-react";
import React from "react";

interface ExitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExitWithoutSaving: () => void;
  onSaveAndExit: () => void;
  title?: string;
  description?: string;
  exitButtonText?: string;
  saveButtonText?: string;
  isSaving?: boolean;
}

const ExitModal: React.FC<ExitModalProps> = ({
  isOpen,
  onClose,
  onExitWithoutSaving,
  onSaveAndExit,
  title = "Exit without saving?",
  description = "All new edits will be lost.",
  exitButtonText = "Exit without Saving",
  saveButtonText = "Save & Exit",
  isSaving = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton
      className="max-w-[420px]"
      isDismissable={!isSaving}
      classNames={{
        wrapper: "z-[9999]",
      }}
    >
      <ModalContent className="p-0">
        {() => (
          <div className="py-6 px-6 flex flex-col items-center relative">
            {/* Close button in top right corner */}
            <button
              onClick={onClose}
              disabled={isSaving}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label="Close"
            >
              <X className="w-5 h-5" strokeWidth={1.5} />
            </button>

            <div className="w-full flex flex-col gap-6">
              <div className="flex flex-col items-center gap-4">
                {/* Header */}
                <h2 className="text-[18px] font-semibold leading-7 text-center text-[#11181C]">
                  {title}
                </h2>

                {/* Description */}
                <p className="text-[14px] text-[#777780] text-center">
                  {description}
                </p>
              </div>

              {/* Action buttons */}
              <div className="flex flex-row w-full gap-4 mt-2">
                <ZButton
                  variant="bordered"
                  size="md"
                  className="flex-1 h-10 text-[16px] border-1 border-[#006FEE] text-[#006FEE]"
                  onClick={onExitWithoutSaving}
                  isDisabled={isSaving}
                >
                  {exitButtonText}
                </ZButton>
                <ZButton
                  color="primary"
                  size="md"
                  className="flex-1 h-10 text-[16px]"
                  onClick={onSaveAndExit}
                  isLoading={isSaving}
                  isDisabled={isSaving}
                >
                  {saveButtonText}
                </ZButton>
              </div>
            </div>
          </div>
        )}
      </ModalContent>
    </Modal>
  );
};

export default ExitModal;
